import { useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import EmbedCodeContainer from 'asset-actions-lib-forms/share/components/EmbedCodeContainer';
import { RegularFormTypes } from 'asset-actions-lib-forms/constants/form';
import ShareLink from 'asset-actions-lib-forms/share/components/ShareLink';
import { DeveloperCode } from 'FormsCommonComponents/DeveloperCode';
import { LockedIcon } from 'foundations-assets/icons/components/LockedIcon';
import EmbedVersions from 'forms-utils-lib/constants/formDefinition/EmbedVersions';
import { ShareTabIds } from 'asset-actions-lib-forms/types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ShareTabbedView({
  createdAt,
  embedType,
  embedVersion,
  formGuid,
  formName,
  hasRawHtmlAccess,
  onClickPreviewShareLink,
  onClose,
  onCopyEmbedCode,
  onCopyShareLink,
  initialTab,
  onCopyDeveloperCode,
  openUpgradeModalForDeveloperCode
}) {
  const isV4Form = embedVersion === EmbedVersions.V4;
  const defaultSelected = initialTab === ShareTabIds.SHARE_LINK_TAB ? ShareTabIds.SHARE_LINK_TAB : embedType === RegularFormTypes.SHAREABLE ? ShareTabIds.EMBED_CODE_TAB : ShareTabIds.SHARE_LINK_TAB;
  const [selected, setSelected] = useState(defaultSelected);
  const onSelectedChange = useCallback(event => {
    const value = event.target.value;
    if (value === ShareTabIds.DEVELOPER_CODE_TAB && !hasRawHtmlAccess) {
      return;
    }
    setSelected(value);
  }, [hasRawHtmlAccess]);
  return /*#__PURE__*/_jsxs(Tabs, {
    "data-test-id": "share-tabbed-view",
    selected: selected,
    onSelectedChange: onSelectedChange,
    children: [/*#__PURE__*/_jsx(Tab, {
      tabId: ShareTabIds.SHARE_LINK_TAB,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.shareDialog.shareLink.title"
      }),
      children: /*#__PURE__*/_jsx(ShareLink, {
        createdAt: createdAt,
        embedVersion: embedVersion,
        formGuid: formGuid,
        onCopyShareLink: onCopyShareLink,
        onClickPreviewLink: onClickPreviewShareLink
      })
    }), /*#__PURE__*/_jsx(Tab, {
      tabId: ShareTabIds.EMBED_CODE_TAB,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.shareDialog.embedCode.title"
      }),
      children: /*#__PURE__*/_jsx(EmbedCodeContainer, {
        embedVersion: embedVersion,
        formGuid: formGuid,
        formName: formName,
        onClose: onClose,
        onCopy: onCopyEmbedCode
      })
    }), isV4Form && /*#__PURE__*/_jsx(Tab, Object.assign({
      "data-test-id": "developer-code-tab",
      tabId: ShareTabIds.DEVELOPER_CODE_TAB,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developerCode.title"
      })
    }, !hasRawHtmlAccess && {
      onClick: openUpgradeModalForDeveloperCode,
      icon: LockedIcon
    }, {
      children: /*#__PURE__*/_jsx(DeveloperCode, {
        formGuid: formGuid,
        onClick: onCopyDeveloperCode
      })
    }))]
  });
}